import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

function upgrade(props) {
  let content = "";
  if (
    props.plan &&
    props.plan.planType === "Trial" &&
    props.account.ecommerceFlag !== "S"
  )
    content = (
      <div className="navbar_upgradenow">
        <div className="upgradenow_content">
          {props.account.expiryDays < 1 ? (
            <p>Your free trial has expired!</p>
          ) : (
            <React.Fragment>
              <p>
                Your free trial expires{" "}
                {props.account.expiryDays === 1 ? "" : "in "}
              </p>
              <p className="semi_strong">
                {props.account.expiryDays === 1
                  ? "Today"
                  : props.account.expiryDays + " Days"}
              </p>
            </React.Fragment>
          )}
        </div>
        <NavLink to="/mirror/account/planOptions" className="upgradenow_btn">
          <p>Upgrade Now!</p>
        </NavLink>
      </div>
    );

  return content;
}

function mapStateToProps(state) {
  return {
    account: state.account,
    plan: state.account.plan
  };
}

export default connect(mapStateToProps)(upgrade);
